import styled from "@emotion/styled";
import theme from "@theme";

const Button = styled.button`
  width: 100%;
  border: none;
  background: ${theme.gradient.themeGradient};
  color: ${theme.colors.white};
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 5px;
  margin: 10px 0px 5px 0px;
  height: 35px;
  text-align: center;
  gap: 10px;
  border-radius: 8px;
  opacity: 0px;
  @media (min-width: 768px) {
    width: 100%; /* Adjust for larger screens */
  }
  @media (max-width: 768px) {
    width: 100%; /* Adjust for larger screens */
  }
`;

const SC = {
  Button,
};

export default SC;
